import { Link } from "react-router-dom";
import { Seo } from "@/components/common/Seo";

export default function NotFound() {
  return (
    <div className="shell flex min-h-[70vh] flex-col justify-center py-32" data-testid="not-found">
      <Seo title="Page not found" />
      <p className="label">404</p>
      <h1 className="font-display mt-6 text-4xl font-black tracking-tight text-white sm:text-5xl">
        This page moved, or never existed.
      </h1>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="rounded-full px-6 py-3.5 text-sm font-medium text-[#08090d]"
          style={{ background: "var(--accent)" }}
        >
          Back home
        </Link>
        <Link
          to="/support"
          data-testid="notfound-support-link"
          className="rounded-full border px-6 py-3.5 text-sm text-white"
          style={{ borderColor: "var(--line)" }}
        >
          Get support
        </Link>
      </div>
    </div>
  );
}
